import styled from 'styled-components';
import ReactModal from 'react-modal';
import Button from '../../atoms/Button';
import { demi, heading4text1, normal } from '../../styles/fonts';
import { getImageUrl } from 'utils';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(33, 34, 66, 0.6)',
    zIndex: 2000,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: 0,
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'transparent',
    border: 'none',
  },
};

const Wrapper = styled.div<{ minWidth?: number }>`
  display: flex;
  flex-direction: column;
  width: 480px;
  //height: 458px;
  padding: 18px 24px 22px 24px;
  border-radius: 4px;
  box-shadow: 0 6px 10px -5px rgba(33, 34, 66, 0.04), 0 6px 30px 5px rgba(33, 34, 66, 0.08),
    0 16px 24px 2px rgba(33, 34, 66, 0.12);
  background-color: #fff;

  @media (max-width: 480px) {
    width: 90%;
    min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : '0')};
    height: 100%;
    padding: 18px 16px 22px 16px;
    margin: 0 auto;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Title = styled.div`
  text-align: center;
  font-size: 16px;
  ${demi};

  @media (min-width: 576px) {
    ${heading4text1};
    ${demi};
  }
`;

const Close = styled.div`
  width: 32px;
  height: 32px;
  margin-left: auto;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
`;

export const ICClose = styled.div`
  width: 20px;
  height: 20px;
  padding: 4px;
  background-image: ${getImageUrl('/icons/ic-close.svg')};
`;

const Content = styled.div``;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
`;

const CancelButton = styled(Button)`
  ${normal};
  ${demi};
  color: var(--navy-600);
  border-radius: 4px;
  border: solid 1px var(--navy-200);
  margin-right: 8px;
`;

const ConfirmButton = styled(Button)`
  ${normal};
  ${demi};
`;

const Modal = (
  props: ReactModal.Props & {
    close?: () => void;
    title: string;
    content: React.ReactElement;
    footer: { cancel?: { label: string }; confirm?: { label: string; onClick: () => void } };
    minWidth?: number;
  }
) => {
  const { cancel, confirm } = props.footer;

  return (
    <ReactModal
      style={customStyles}
      shouldCloseOnOverlayClick
      onRequestClose={props.close}
      ariaHideApp={false}
      {...props}
    >
      <Wrapper minWidth={props.minWidth}>
        <Header>
          {props.close && (
            <Close onClick={props.close}>
              <ICClose />
            </Close>
          )}
        </Header>
        <Title>{props.title}</Title>
        <Content>{props.content}</Content>
        <Footer>
          {cancel && <CancelButton size="mid">{cancel.label}</CancelButton>}
          {confirm && (
            <ConfirmButton primary size="mid" onClick={confirm.onClick}>
              {confirm.label}
            </ConfirmButton>
          )}
        </Footer>
      </Wrapper>
    </ReactModal>
  );
};

export default Modal;
